import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { AutofocusModule } from '®shared/autofocus';
import { TextareaAutosizeModule } from '®shared/textarea-autosize';

import { InlineNoteEditorComponent } from './inline-note-editor.component';

@NgModule({
  imports: [
    AutofocusModule,
    CommonModule,
    ReactiveFormsModule,
    TextareaAutosizeModule,
    TooltipModule,
  ],
  declarations: [InlineNoteEditorComponent],
  exports: [InlineNoteEditorComponent],
})
export class InlineNoteEditorModule {}
